import { IconButton, IconPencil, SwaggerHubIcon } from '@smartbear/swagger-portal-component-library'
import { useTranslation } from 'react-i18next'
import { useNavigation } from 'react-router'

import { TooltipWrapper } from '~/portal/components/TooltipWrapper'

export interface EditContentButtonsProps {
  contentUrl?: string,
  shubUrl?: string,
}

export const EditContentButtons = ({
  contentUrl,
  shubUrl,
}: EditContentButtonsProps) => {
  const { t } = useTranslation()
  
  const { location, state } = useNavigation()

  return (
    <>
      {contentUrl ? (
        <TooltipWrapper
          content={t('consumer.edit.buttons.manageContent.tooltip')}
          trigger="hover"
          wrapperClassName="flex"
          defaultComp={
            <IconButton
              aria-label={t('consumer.edit.buttons.manageContent.tooltip')}
              icon={<IconPencil />}
              to={contentUrl}
              loading={location?.pathname === contentUrl && state === 'loading'}
              outline={true}
              size="s"
              className="sp-api-viewer-edit-button border-(--sp-color-border-strong) dark:border-(--sp-color-border-strong)"
            />
          }
          placement="bottom-end"
        />
      ) : null}
      {shubUrl ? (
        <TooltipWrapper
          content={t('consumer.edit.buttons.editInSwaggerHub.tooltip')}
          trigger="hover"
          wrapperClassName="flex"
          defaultComp={
            <IconButton
              aria-label={t('consumer.edit.buttons.editInSwaggerHub.tooltip')}
              icon={<SwaggerHubIcon />}
              target="_blank"
              to={shubUrl}
              outline={true}
              size="s"
              className="sp-api-viewer-studio-button border-(--sp-color-border-strong) dark:border-(--sp-color-border-strong)"
            />
          }
          placement="bottom-end"
        />
      ) : null}
    </>
  )
}